import {
  IEWACalendarPeriod,
  IEWADetails,
  IEWASchedulingValidation,
  IMenhirEWACalendarPeriod,
  IMenhirEWADetails,
  IMenhirEWASchedulingValidation,
} from '@/common/integrations/menhir/employee/salary/salary.types';

export const transformEWADetails = (
  response: IMenhirEWADetails
): IEWADetails => ({
  employeeId: response.employee_id,
  availableAmount: response.available_amount,
  paidSoFar: response.paid_so_far,
  remainingSalary: response.remaining_salary,
  monthlyNetSalary: response.monthly_net_salary,
  dailyAmount: response.daily_amount,
  status: response.status,
  payday: response.payday,
  lockPeriodBeforePayday: response.lock_period_before_payday,
  isBlockedDay: response.is_blocked_day,
  scheduling: response.scheduling
    ? {
        frequency: response.scheduling.frequency,
        frequencyChange: response.scheduling.frequency_change,
        nextPayment: {
          date: response.scheduling.next_payment.date,
          amount: response.scheduling.next_payment.amount,
        },
      }
    : undefined,
  //@TODO: because BE doesn't have modules yet, we'll default to one-off array to not break new logic.
  modules: response.modules ?? ['one-off'],
});

export const transformEWASchedulingValidation = (
  response: IMenhirEWASchedulingValidation
): IEWASchedulingValidation => ({
  frequency: response.frequency,
  possibleTransfersPerMonth: response.possible_transfers_per_month,
  amountPerTransfer: response.amount_per_transfer,
});

export const transformEWACalendar = (
  calendar: IMenhirEWACalendarPeriod[][]
): IEWACalendarPeriod[][] =>
  calendar.map((period) =>
    period.map((day) => ({
      date: day.date,
      accumulatedAmount: day.accumulated_amount,
      requestedAmount: day.requested_amount,
      scheduledAmount: day.scheduled_amount,
      type: day.type,
    }))
  );
